export default "__VITE_ASSET__0e2ba004__"